'use client';

import { POPUPS } from '@/app/components/popup/constants';
import { useStore } from '@/store/store';
import { getLocalStorageRewardsMachineWelcome } from '@/utils/reward-machine/reward-machine-helper';
import type { FC, PropsWithChildren, SyntheticEvent } from 'react';

export const RewardMachineWelcomeModalTrigger: FC<PropsWithChildren> = ({ children }) => {
    const opened = useStore((state) => state.rewardMachine.welcomeModal.opened);
    const welcomeModalData = useStore((state) => state.rewardMachine.welcomeModal.welcomeModalData);
    const setOpened = useStore((state) => state.rewardMachine.welcomeModal.setOpened);
    const popup = useStore((state) => state.popup);

    // TODO: once the store is persisted remove localStorage check from here
    if (opened || getLocalStorageRewardsMachineWelcome() === 'true') {
        return <>{children}</>;
    }

    const handleClick = (e: SyntheticEvent) => {
        const target = e.target as HTMLElement;
        if (target.closest('[data-reward-machine-info-link]')) {
            return;
        }

        if (!target.closest('[data-reward-machine-from-banner]')) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        setOpened();
        popup.queuePopup({
            type: POPUPS.REWARD_MACHINE_WELCOME_MODAL,
            params: welcomeModalData !== null && welcomeModalData !== undefined ? { welcomeModalData } : {}
        });
    };

    return (
        <div className="reward-machine-welcome-modal-trigger" onClickCapture={handleClick}>
            {children}
        </div>
    );
};
